import type React from 'react'

import { cn } from '@/lib/utils'

export interface DialogProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
  ariaLabel?: string
}

export function Dialog({ isOpen, onClose, children, className, ariaLabel }: DialogProps) {
  if (!isOpen) return null
  return (
    <div
      className="modal-backdrop flex items-center justify-center animate-fade-in p-4"
      aria-modal="true"
      role="dialog"
      aria-label={ariaLabel}
      onClick={onClose}
    >
      <div
        className={cn('bg-white rounded-lg p-6 shadow-xl max-w-md w-full max-h-[90vh] flex flex-col animate-scale-in', className)}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}

export function DialogHeader({ children }: { children: React.ReactNode }) {
  return <div className="mb-4">{children}</div>
}

export function DialogTitle({ children }: { children: React.ReactNode }) {
  return <h3 className="text-lg font-semibold text-gray-900">{children}</h3>
}

export function DialogDescription({ children }: { children: React.ReactNode }) {
  return <div className="text-sm text-gray-600 mt-2">{children}</div>
}

export function DialogFooter({ children }: { children: React.ReactNode }) {
  return <div className="flex justify-end gap-3 mt-6">{children}</div>
}


